import moment from 'moment';
import dateFormat from 'config/dateFormat';

const patientDobToAge = (dob) => {
  const ageInYears = moment().diff(moment(dob, dateFormat), 'years');
  if (ageInYears > 0) {
    return ageInYears;
  }
  let ageInMonths = moment().diff(moment(dob, dateFormat), 'months');
  if (ageInMonths > 0) {
    ageInMonths = `0${ageInMonths}`.slice(-2);
    return `.${ageInMonths}`;
  }
  return 0;
};

export default patientDobToAge;



// WEBPACK FOOTER //
// ./src/utils/patientDobToAge.js